export default "__VITE_ASSET__D8sLqjrA__"